import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { AddSimpleChoice } from './AddSimpleChoice';
import { SimpleChoice } from './SimpleChoice';
import { SimpleChoice as TSimpleChoice } from '../../types';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any|null;
	contents: (TSimpleChoice & { id: string; updatedAt:string|null; createdAt: string })[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
};

export function SimpleChoiceList(props: Props) {
	const {scrollRef, contents: simpleChoices, hasMore, refetchContent, loadMore} = props;

	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>Simple Choice</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} className={style.textList} style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{simpleChoices.length>0?
					<InfiniteScroll
						dataLength={simpleChoices.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}>
						{simpleChoices.map((el) => (
							<SimpleChoice key={el.id} simpleChoice={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add Simple Choice</span>
				</button>
			}
			{isOpen && (
				<AddSimpleChoice
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
